import { useMemo } from 'react';
import DOMPurify from 'dompurify';
import { marked } from 'marked';

import { cn } from '../../lib/cn';
import styles from './MarkdownView.module.css';

marked.setOptions({ gfm: true, breaks: true });

export type MarkdownViewProps = {
  readonly value: string;
  readonly className?: string;
};

/**
 * Markdown с обязательной санитизацией (UC-ISS-02 AC4):
 * никакого script/iframe из пользовательского текста.
 */
export function renderMarkdown(value: string): string {
  const raw = marked.parse(value, { async: false });
  return DOMPurify.sanitize(raw, {
    FORBID_TAGS: ['script', 'iframe', 'object', 'embed', 'form', 'style'],
    FORBID_ATTR: ['style', 'onerror', 'onload', 'onclick'],
  });
}

export function MarkdownView({ value, className }: MarkdownViewProps) {
  const html = useMemo(() => renderMarkdown(value), [value]);

  if (value.trim().length === 0) {
    return <p className={cn(styles['empty'], className)}>Описание не заполнено</p>;
  }

  return (
    <div
      className={cn(styles['markdown'], className)}
      // HTML уже прошёл DOMPurify.sanitize.
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
